import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface DialogState {
    [key: string]: {
        isOpen: boolean;
    };
}

interface DialogAction {
    keyDialog: string;
    isOpen: boolean;
}

const initialState: DialogState = {};

export const dialogSlice = createSlice({
    name: 'dialog',
    initialState,
    reducers: {
        setDialogAction: (state, action: PayloadAction<DialogAction>) => {
            if (!state[action.payload.keyDialog]) {
                state[action.payload.keyDialog] = {
                    ...initialState[action.payload.keyDialog],
                    isOpen: action.payload.isOpen,
                };
            }

            state[action.payload.keyDialog] = action.payload;
        },
        removeDialogAction: (state, action: PayloadAction<string>) => {
            delete state[action.payload];
        },
    },
});

export const { setDialogAction, removeDialogAction } = dialogSlice.actions;

export default dialogSlice.reducer;
